import {
  dismiss,
  update,
  error,
  message,
  warning,
  success,
  info,
} from "react-toastify-redux";

const services = new Services(null) as any;
// toast actions
import Services from "../../services/Services";

const TOGGLE_LOADERS = "schoolPerceptions/toggleLoaders";
const GET_PERCEPTIONS = "schoolPerceptions/getPerceptions";
const GET_COHORTS_DATA = "schoolPerceptions/getCohorts";
const GET_YEARGROUPS = "schoolPerceptions/getYearGroups";
const GET_COHORTS_PERCEPTIONS_DATA = "schoolPerceptions/getCohortsPerceptionData"
const GET_COHORT_PERCEPTIONS = "schoolPerceptions/getCohortsPerceptions";
const UPDATE_MULTIPLE_VALS = "schoolPerceptions/updateMultipleVals"


const INITIAL_STATE = {
    // departments: [],
    // yearGroups: [], 
    cohorts: [],
    cohortsLoaded: false,
    yeagroupsLoaded: false,
    perceptionsList: [],
    perceptionsData: null,
    selectedPerception: null,
    cohortID: null,
    yearGroup: "",
    studentCount: null,
    perceptionsListLoaded: false,
    perceptionsDataLoaded: false,
    currentUserType: "",
    isLoading: false,
    firstClickDone: false
}

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;

    switch(type) {
        // case GET_YEARGROUPS_DEPARTMENTS:
        //     return {
        //         ...state,
                
        //     }
        case GET_PERCEPTIONS: 
            return {
                ...state,
                perceptionsList: payload.perceptionsList,
                perceptionsListLoaded: payload.loaded
            };
        
        case GET_COHORTS_DATA: 
            return {
                ...state,
                cohorts: payload.cohorts,
                cohortsLoaded: payload.cohortsLoaded,
                currentUserType: payload.userType
            };

        case GET_COHORT_PERCEPTIONS: 
        return {
            ...state,
            perceptionsData: payload
        };

        case GET_COHORTS_PERCEPTIONS_DATA: {
            return {
                ...state,
                ...payload
            }
        }

        case GET_YEARGROUPS:
            return {
        ...state,
        yearGroups: payload.yearGroups,
        yearGroupsLoaded: payload.loaded
        };

        case TOGGLE_LOADERS: 
            return {
                ...state,
                ...payload
            };

            case UPDATE_MULTIPLE_VALS: {
                return {
                    ...state,
                    ...payload
                }
            }

        default: return state;
    }
}

export const getPerceptions = () => async (dispatch) => {
    const res = await services.adminAPI.getPerceptions();
    const perceptionsList = res.data.perceptions;
    dispatch({type: GET_PERCEPTIONS, payload: {perceptionsList, loaded: true}});
}

export const getYearGroups = (userId) => async (dispatch) => {
    const res = await services.institutionsAPI.getInstitutionYearGroups(userId);
    const yearGroups = res.data.year_groups;
    dispatch({type: GET_YEARGROUPS, payload: {yearGroups, loaded: true}});
}

export const getCohorts = (userId, userType) => async (dispatch) => {
    const res = await services.institutionsAPI.getGenericCohortsRes(userId, userType);

    if(res.ok) {
        dispatch({type: GET_COHORTS_DATA, payload: {cohorts: res.data.cohorts, cohortsLoaded: true, userType}})
    }else {
        dispatch(error("Unable to fetch your cohorts"));
    }

}

export const getCohortsPerceptionData = (currentUser, userType, cohortID, perceptionID, yearGroup) => async (dispatch) => {

    console.log("yearGroup", yearGroup);
     const perceptionsRes =
      await services.institutionsAPI.getInstitutionCohortPerceptions(
        currentUser,
        userType,
        cohortID,
          perceptionID,
        yearGroup
      );
    if (perceptionsRes.ok) {
      dispatch({type: GET_COHORTS_PERCEPTIONS_DATA , payload: {
        perceptionsData: perceptionsRes.data.users,
        perceptionsDataLoaded: true,
        isLoading: false,
      }});
    }
}

export const toggleLoaders = (loaderObject) => async (dispatch) => {
// pass an object with the loader you'd like to change
    dispatch({type: 'TOGGLE_LOADERS', payload: loaderObject})
}

export const updateMultipleVals = (valuesObj) => async (dispatch) => {
    console.log({valuesObj})
    dispatch({type: UPDATE_MULTIPLE_VALS, payload: valuesObj});
}





// WEBPACK FOOTER //
// ./src/redux/ducks/schoolPerceptions.ts